import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private positionYSubject: Subject<number> = new Subject();

  public changePosition(val: number): void {
    this.positionYSubject.next(val);
  }

  public getPosition(): Observable<number> {
    return this.positionYSubject.asObservable();
  }
}
